const handleDeleteEquipmentServiceFail = {
  title: 'EL SERVICIO NO SE PUEDE BORRAR',
  message: 'No se puede borrar. Usado por',
  companies: 'Compañías',
  items: 'Itens',
  equipmentmodels: 'Tipos de Equipos',
  equipments: 'Equipos',
  inspections: 'Inspecciones',
  itemverifications: 'Elementos de verificación',
  default: 'Colección Genérica'
};

export default handleDeleteEquipmentServiceFail;
